<template>
  <div class="content-tab loopprotection">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body">
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="describe content-body-header">
          {{$t('loopProtection.describe')}}
        </div>
        <div>
          <span class="title">{{$t('loopProtection.title')}}</span>
          <toggle :on="config.loopProtection" @click.native="onSwitchBtn()"></toggle>
        </div>
        <div class="forminput">
          <span class="title">{{$t('loopProtection.shutdownTime')}}</span>
          <input class="item" type="text" name="shutdownTime" @keyup="onBlur"  v-model="config.shutdownTime" v-validate="'between:0,604800|required'" :class="{'error': (errors.has('shutdownTime'))}">
          <div class="item">
            <label>{{$t('loopProtection.seconds')}}</label>
            <div class="icon-info info-color ft-14" v-on:click="onInfoClick($event)"/>
          </div>
          <span class="error-message" v-show="errors.has('shutdownTime')">{{ $t('loopProtection.shutdownTimeValid', {range: '0 - 604800'}) }}</span>
        </div>
        <div class="content-body-header">
          <span class="title">{{$t('loopProtection.loopProtectionStauts')}}</span>
          <button class="q-button blue-btn-full footer-btn" @click="refresh" :title="$t('loopProtection.reset')">{{$t('loopProtection.reset')}}</button>
        </div>
        <div class="formRow group-table" ref="tableContent">
          <fixed-table ref="portTable" :data="data" :use-page="false" :header-height="40">
            <div class="right-header" slot="right-header">
              <column style="width:10%;">{{$t('loopProtection.port')}}</column>
              <column style="width:15%;">{{$t('action')}}</column>
              <column style="width:25%;">{{$t('loopProtection.loops')}}</column>
              <column style="width:25%;">{{$t('loopProtection.looping')}}</column>
              <column style="width:25%;">{{$t('loopProtection.lastLoop')}}</column>
            </div>
            <template slot="rows" slot-scope="props">
                <div class="link-row">
                  <row class="right" :props="props" :title="getTooltips(props.data)">
                    <div class="data" style="width:10%;">{{getPort(props.data)}}</div>
                    <div class="data" style="width:15%;">
                      <toggle :on="getAction(props.data)" @click.native="onSwitchBtn(props)" :disabled="isDisabled(props.data)"></toggle>
                    </div>
                    <div class="data" style="width:25%;">{{getLoops(props.data)}}</div>
                    <div class="data" style="width:25%;">{{getLooping(props.data)}}</div>
                    <div class="data" style="width:25%;">{{getLastLoop(props.data)}}</div>
                  </row>
                </div>
              </template>
          </fixed-table>
        </div>
      </scrollbar>
      <div class="content-body-footer">
        <button class="q-button blue-btn-full right" :title="$t('save')" @click="onSaveClick()" :disabled="!isButtonEnable">{{$t('save')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
import toggle from './module/Toggle'
import moment from 'moment'
import { mapActions, mapState, mapMutations } from 'vuex'

const SHUTDOWN_TIME_MIN = 0
const SHUTDOWN_TIME_MAX = 604800

export default {
  name: 'LoopProtection',
  components: {
    fixedTable,
    row,
    column,
    toggle
  },
  data () {
    return {
      isShowLoading: false,
      isButtonEnable: false,
      dateformat: 'YYYY/MM/DD',
      timeformat: 'HH:mm:ss',
      config: {
        loopProtection: false,
        transmissionTime: 5,
        shutdownTime: 180,
        Ports: ''
      },
      originalConfig: null,
      data: null,
      pollingInterval: null,
      originalData: null,
      waitStatus: false
    }
  },
  created: async function () {
    this.getData()
  },
  beforeDestroy () {
    clearInterval(this.pollingInterval)
    this.pollingInterval = null
  },
  beforeRouteLeave (to, from, next) {
    if (this.isDataChanged) {
      next(false)
    } else {
      next()
    }
  },
  watch: {
    isButtonEnable: function (value) {
      if (!value) {
        this.$store.commit('updateDataChanged', false)
      } else {
        this.$store.commit('updateDataChanged', true)
      }
    },
    showFullLoading: function (value) {
      if (value) {
        clearInterval(this.pollingInterval)
        this.pollingInterval = null
      }
    },
    currentUser: {
      handler (value) {
        if (!value) {
          clearInterval(this.pollingInterval)
          this.pollingInterval = null
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function () {
    let me = this
    setTimeout(() => {
      this.pollingInterval = setInterval(() => {
        me.loopProtectState(false)
      }, me.intervalTime)
    }, 1500)
  },
  methods: {
    ...mapMutations(['openModal', 'closeModal']),
    ...mapActions(['getLoopProtectConfig', 'getLoopProtectState', 'setLoopProtectConfig', 'setLoopProtectReset', 'getRSTPconfig', 'saveSysConf']),
    getData: async function () {
      this.isShowLoading = true
      this.isButtonEnable = false
      this.data = this.initData()
      await this.getLoopProtectConfig()
        .then((res) => {
          if (res.data.error_code === 200) {
            this.config.loopProtection = res.data.result.Enabled
            if (!res.data.result.Enabled) this.isShowLoading = false
            this.config.transmissionTime = res.data.result.TransmitInterval
            this.config.shutdownTime = res.data.result.ShutdownPeriod
            this.originalConfig = JSON.parse(JSON.stringify(res.data.result))
            res.data.result.Ports.forEach((item) => {
              let idx = item.Port
              for (let i = 0; i < this.data.length; i++) {
                if (this.data[i].key === idx) {
                  this.data[i].val.Enabled = item.Enabled
                }
              }
            })
          }
        })
        .catch((err) => {
          this.setErrorWindow(err)
        })
      await this.loopProtectState(true)
      this.originalData = JSON.parse(JSON.stringify(this.data))
    },
    loopProtectState: async function (isUpdateAction) {
      let me = this
      return new Promise(async (resolve) => {
        if (me.config.loopProtection) {
          await me.getLoopProtectState()
            .then((res) => {
              if (res.data.error_code === 200) {
                // sort by key
                let tempResult = res.data.result
                if (tempResult) {
                  tempResult.sort(function (a, b) {
                    return Number(a.key) - Number(b.key)
                  })
                  if (me.data) {
                    me.data.forEach((item) => {
                      for (let i = 0; i < tempResult.length; i += 1) {
                        if (item.key === 'all') continue
                        if (item.key === tempResult[i].key) {
                          if (isUpdateAction) {
                            // item.val = tempResult[i].val
                          } else {
                            if (!me.waitStatus) me.isShowLoading = false
                            item.val.LoopDetected = tempResult[i].val.LoopDetected
                            item.val.LoopCount = tempResult[i].val.LoopCount
                            item.val.LastLoop = tempResult[i].val.LastLoop
                          }
                          break
                        } else {
                          if (i === tempResult.length - 1) {
                            // This port is a part of LAG
                            // item.isNormalPort = false
                          }
                        }
                      }
                    })
                  }
                }
                if (isUpdateAction) {
                  me.checkAllPort()
                }
              }
              resolve()
            })
            .catch((err) => {
              me.setErrorWindow(err)
            })
        }
      })
    },
    setErrorWindow (err) {
      this.$store.commit('setErrorWin', {
        show: true,
        data: {
          error_message: err,
          result: null,
          title: this.$t('warning')
        },
        config: {}
      })
    },
    onSwitchBtn: function (data) {
      if (data) {
        const idx = data.index
        this.data[idx].val.Enabled = !this.data[idx].val.Enabled
        if (idx === 0 && this.data[idx].key === 'all') {
          this.data.filter(item => item.key !== 'all' && item.isNormalPort).forEach((item) => {
            item.val.Enabled = this.data[0].val.Enabled
          })
        }
        this.checkAllPort()
      } else {
        this.config.loopProtection = !this.config.loopProtection
      }
      this.checkBtnValidate()
    },
    onBlur () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.checkBtnValidate()
        } else {
          this.isButtonEnable = false
        }
      }).catch(() => {
        this.isButtonEnable = false
      })
    },
    checkBtnValidate: function () {
      let tempConfig = {
        Enabled: this.config.loopProtection,
        TransmitInterval: Number(this.config.transmissionTime),
        ShutdownPeriod: Number(this.config.shutdownTime),
        Ports: this.config.Ports
      }
      let check1 = this.$compareObj(this.originalConfig, tempConfig)
      let check2 = this.$compareObj(this.originalData, this.data)
      this.isButtonEnable = !check1 || !check2
    },
    onSaveClick: async function () {
      let me = this
      if (!this.errors.has('transmissionTime') & !this.errors.has('shutdownTime')) {
        let canSet = false
        if (this.config.loopProtection === true) {
          await this.getRSTPconfig()
            .then((res) => {
              if (res.error_code === 200) {
                canSet = res.result[0].val === 2
                if (!canSet) {
                  this.isShowLoading = false
                  this.onSwitchBtn()
                  this.openModal('loop-rstp-conflict-modal')
                  this.$modal.show('loop-rstp-conflict-modal')
                  this.isButtonEnable = false
                }
              }
            })
            .catch((err) => {
              this.setErrorWindow(err)
            })
        } else {
          canSet = true
        }
        if (canSet) {
          me.waitStatus = true
          this.isShowLoading = true
          let data = {
            'data': {
              'Enabled': this.config.loopProtection,
              'TransmitInterval': Number(this.config.transmissionTime),
              'ShutdownPeriod': Number(this.config.shutdownTime)
            }
          }
          data = this.checkPerPort(data)
          this.setLoopProtectConfig(data)
            .then(async (res) => {
              if (res.data.error_code === 200) {
                await me.saveSysConf()
                me.waitStatus = false
                this.getData()
              }
            })
            .catch((err) => {
              this.setErrorWindow(err)
            })
        }
      }
    },
    refresh: function (type) {
      this.isShowLoading = true
      this.setLoopProtectReset(null)
        .then((res) => {
          if (res.data.error_code === 200) {
            this.loopProtectState(true)
          }
        })
        .catch((err) => {
          this.setErrorWindow(err)
        })
        .finally(() => {
          this.isShowLoading = false
        })
    },
    onInfoClick: function (event) {
      let message = [{text: this.$t('loopProtection.shutdownTimeInfo', {0: SHUTDOWN_TIME_MIN, 1: SHUTDOWN_TIME_MAX})}]
      this.$store.commit('updateInfoTips', !this.showInfoTips)
      if (this.showInfoTips) {
        this.$store.commit('updateInfoData', {
          message: message,
          event: event
        })
      }
    },
    getPort: function (data) {
      if (data.key === 'all') return this.$t('all')
      let num = Number(data.key)
      if (num > this.portNumber) {
        return 'LAG ' + (num - this.lagStartNum)
      } else {
        return num
      }
    },
    getAction: function (data) {
      return data.val.Enabled
    },
    isDisabled: function (data) {
      if ((this.originalConfig && !this.originalConfig.Enabled)) return true
      return !data.isNormalPort
    },
    getLoops: function (data) {
      if (data.key === 'all') return '-'
      if (!data.val.Enabled || (this.originalConfig && !this.originalConfig.Enabled)) {
        return 0
      }
      return data.val.LoopCount
    },
    getLooping: function (data) {
      if (data.key === 'all') return '-'
      if (this.portMap.get(Number(data.key))) return '-'
      if (!data.val.Enabled || !this.originalConfig.Enabled) {
        return '-'
      }
      return data.val.LoopDetected === 2 ? this.$t('overview.normal') : this.$t('loopProtection.looping')
    },
    getLastLoop: function (data) {
      if (data.key === 'all') return '-'
      if (!data.val.Enabled || !this.originalConfig.Enabled) {
        return '-'
      }
      if (Number(data.val.LastLoop) === 0) {
        return '-'
      } else {
        let time = moment.unix(data.val.LastLoop).utc()
        if (this.timeConfig.isNTP) {
          time.utcOffset(this.timeConfig.timezone)
        }
        return time.format(this.dateformat + ' ' + this.timeformat)
      }
    },
    checkPerPort: function (data) {
      let result = data
      let ports = []
      if (this.data && this.originalData && this.data.length === this.originalData.length) {
        for (let i = 0; i < this.data.length; i += 1) {
          if (this.data[i].key === 'all') continue
          if (this.data[i].val.Enabled !== this.originalData[i].val.Enabled) {
            ports.push({
              'Port': this.data[i].key,
              'Enabled': this.data[i].val.Enabled
            })
          }
        }
      }
      if (ports.length > 0) {
        result.data['Ports'] = ports
      }
      return result
    },
    getTooltips: function (data) {
      if (data.key === 'all') return ''
      if (this.portMap.get(Number(data.key))) {
        return this.$t('lag.alreadyJoin')
      } else {
        return ''
      }
    },
    checkEnabled: function (idx) {
      if (this.originalConfig && !this.originalConfig.Enabled) return false
      if (this.data) {
        return this.data[idx - 1].val.Enabled
      } else {
        return false
      }
    },
    initData: function () {
      let tempData = []
      for (let idx = 1; idx <= this.portNumber + this.lagGroupMap.size; idx++) {
        let enable = this.checkEnabled(idx)
        let isNormalPort = !(this.portMap.get(idx))
        // init table data
        tempData.push({
          key: ((idx < this.portNumber + 1) ? idx : idx + (this.lagStartNum - this.portNumber)).toString(),
          val: {
            'Enabled': enable,
            'LoopDetected': 2,
            'LoopCount': 0,
            'LastLoop': 0
          },
          'isNormalPort': isNormalPort
        })
      }
      // init all port state
      tempData.unshift({
        key: 'all',
        val: {
          Enabled: false,
          LoopDetected: 2,
          LoopCount: 0,
          LastLoop: 0
        },
        isNormalPort: true
      })
      return tempData
    },
    checkAllPort: function () {
      // find the all port index
      const pos = this.data.map(item => item.key).indexOf('all')
      if (pos >= 0) {
        let checkingArray = this.data.filter(item => item.key !== 'all' && item.isNormalPort)
        let enabledCount = checkingArray.filter(item => item.val.Enabled)

        // update the state of all port buttons
        this.data[pos].val.Enabled = checkingArray.length === enabledCount.length
      }
    }
  },
  computed: {
    ...mapState({
      showInfoTips: state => state.app.showInfoTips,
      isDataChanged: state => state.app.isDataChanged,
      timeConfig: state => state.module.timeConfig,
      intervalTime: state => state.app.intervalTime,
      showFullLoading: state => state.module.showFullLoading,
      currentUser: state => state.module.currentUser,
      lagStartNum: state => state.module.lagStartNum,
      lagGroupMap: state => state.module.lagGroupMap,
      portNumber: state => state.module.portNum,
      portMap: state => state.module.portMap
    })
  }
}
</script>

<style lang="scss" scoped>

.loopprotection {
  position: relative;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  .content-body {
    padding: 10px;
    .scrollbar-body {
      height: calc(100% - 50px);
      .group-table{
        height: 100%;
        width: calc(100% - 10px);
        .data.priority {
          display: flex !important;
          justify-content: start;
          margin: auto;
          .priority-input {
            width: 50px;
            margin: 0px 10px;
          }
          div {
            margin: auto 0px;
            cursor: pointer;
            &.disabled {
              opacity: 0.5;
              cursor: default;
              pointer-events: none;
            }
          }
        }
      }
      .forminput {
        margin: 10px 0px 10px 23px;
        display: grid;
        grid-template-columns: max-content min-content max-content;
        grid-template-rows: auto auto;
        align-items: center;
        .title {
          font-size: 14px;
          color: #000000;
          font-weight: 500;
          width: auto;
          display: inline-block;
          font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
        }
        .item {
          margin: 0px 0px 0px 10px;
          label {
            font-size: 14px;
            color: #000000;
            font-weight: 500;
            width: auto;
            font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
          }
        }
        input {
          border: 1px solid #979797;
          border-radius: 4px;
          font-size: 14px;
          height: 30px;
          color: #000000;
          line-height: 30px;
          width: 68px;
          margin-left: 10px;
          font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
        }
        .error-message {
          margin-left: 10px;
          font-size: 14px;
          color: #f30707;
          width: 400px;
          display: inline-block;
          font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
          grid-column: 2 / span 3;
        }
      }
    }
    .title {
      height: 100%;
      position: relative;
      line-height: 30px;
      font-family: 'Roboto-M' !important;
    }
    .content-body-header {
      position: relative;
      margin-bottom: 10px;
      > span {
        justify-content: flex-start;
      }
      > button {
        float: right;
        margin-right: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoopProtection.vue